import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { MainLayout } from './MainLayout';

export function MainLayoutWrapper() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <MainLayout currentPath={location.pathname} onNavigate={(path) => navigate(path)}>
      <Outlet />
    </MainLayout>
  );
}
